import { FC } from 'react';

import { ModalRatePlanVasBlock } from '@telialt/core-eshop/src/CartSummaryBox/ValueAddedServices';
import { RatePlanSelector } from '@telialt/core-eshop/src/product/RatePlanSelector/RatePlanSelector';

export const OldRatePlanSelector: FC = () => (
    <>
        <RatePlanSelector />
        <ModalRatePlanVasBlock />
    </>
);
